import { Component, computed, input, ChangeDetectionStrategy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ProductionKeyPerformanceIndicatorEvaluation } from 'src/app/models/production-key-performance-indicator-evaluation.model';
import { CompanyProductDailyStandupEvaluationData } from 'src/app/models/company-product-daily-standup-compliance-kpi-data.model';

@Component({
  selector: 'app-company-product-daily-standup-compliance-details',
  imports: [DatePipe, MatTooltipModule],
  templateUrl: './company-product-daily-standup-compliance-details.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './company-product-daily-standup-compliance-details.component.css',
})
export class CompanyProductDailyStandupComplianceDetailsComponent {
  currentMonthEvaluation = input<ProductionKeyPerformanceIndicatorEvaluation | null>(null);

  dailyData = computed<CompanyProductDailyStandupEvaluationData | null>(() => {
    const data = this.currentMonthEvaluation()?.data;
    return data ? (data as CompanyProductDailyStandupEvaluationData) : null;
  });
}
